
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#1A1FA2" },           // bleu profond (pastilles/accents)
    secondary: { main: "#D32F2F" },         // rouge (chip du lieu)
    text: {
      primary: "#0E0E1A",
      secondary: "#5A5A7A"
    }
  },
  shape: { borderRadius: 18 },              // coins plus arrondis
});


export default theme;
